import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter as Router, Route, Routes, Navigate} from 'react-router-dom'
import axios from 'axios';

import ProtectedRoutes from './utils/protectedRoutes';
import AdminRoutes from './utils/adminRoutes';

import './App.css';

//Actions
import { hydrateUser, updateToken } from './actions/auth';

//Components
import LoginForm from './components/login/loginForm';
import RegisterForm from './components/registration/userRegister';
import Home from './components/views/home';
import Navbar from './components/views/navbar';
import CreateEntry from './components/views/createEntry';
import EditEntry from './components/views/editEntry';
import ActivateUsers from './components/views/activateUsers';
import Impersonate from './components/views/impersonate';
import SingleNote from './components/views/singleNote';
import Dropdowns from './components/views/dropdowns';
import ForgotPassword from './components/login/forgotPass';
import ResetPass from './components/login/resetPass';

function App() {
  const dispatch = useDispatch();
  const currToken = useSelector(state => state.token);
  const currUser = useSelector(state => state.user);
  const storedToken = localStorage.getItem('token');
  const storedUserRaw = localStorage.getItem('user');


  useEffect(() => {
    let storedUser = null;
    try {
      storedUser = storedUserRaw ? JSON.parse(storedUserRaw) : null;
    } catch (error) {
      storedUser = null;
    }
    // Hydrate from localStorage after refresh
    if ((!currToken || !currUser?._id) && storedToken && storedUser?._id) {
      dispatch(hydrateUser({ user: storedUser, token: storedToken }));
      return;
    }

    if (!currToken && storedToken) {
      dispatch(updateToken(storedToken));
    }

    if (currToken) {
      localStorage.setItem('token', currToken);
      axios.defaults.headers.common.Authorization = `Bearer ${currToken}`;
    } else {
      delete axios.defaults.headers.common.Authorization;
    }
    if (currUser?._id) {
      localStorage.setItem('user', JSON.stringify(currUser));
    }
  }, [currToken, currUser, storedToken, storedUserRaw, dispatch]);

  return (
    <Router>
        <Navbar />

        <Routes>
          <Route path="/" element={<ProtectedRoutes/>}>
            <Route index element={<Navigate replace to="/home" />} />

            <Route path="/home" element={<Home/>} />
            <Route path="/editEntry/:id" element={<EditEntry/>} />
            <Route path="/createEntry" element={<CreateEntry/>} />
            <Route path="/createEntry/:id" element={<CreateEntry/>} />
            <Route path="/singleNote/:id" element={<SingleNote/>} />

            <Route element={<AdminRoutes/>}>
              <Route path="/activateUsers" element={<ActivateUsers/>} />
              <Route path="/impersonate/:id" element={<Impersonate/>} />
              <Route path="/dropdowns" element={<Dropdowns/>} />
            </Route>

          </Route>
            
          <Route path="/login" element={<LoginForm/>} />
          <Route path="/register" element={<RegisterForm/>} />
          <Route path="/forgot" element={<ForgotPassword/>} />
          <Route path="/reset/:token" element={<ResetPass/>} />
        </Routes>
    </Router>
  )
};

export default App;
